module.exports = __webpack_public_path__ + "img/rightAni.a0816829.png";